import styled from 'styled-components';

export const OpoHeaderWrapper = styled.div`
    --hdr-bg: #FFFFFF;
    --hdr-border: #E3E8EF;
    --hdr-text: #3A4756;
    --hdr-text-strong: #16365A;
    --hdr-hover: #F3F5F8;
    --hdr-active: #EEF3F9;
    --hdr-control-border: #D5DBE3;

    & > .navbar,
    & > .navbar.navbar-inverse {
        display: flex;
        align-items: center;
        background-color: var(--hdr-bg);
        background-image: none;
        border: none;
        border-bottom: 1px solid var(--hdr-border);
        border-radius: 0 !important;
        margin-bottom: 0;
        min-height: 56px;
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
    }

    & > .navbar:before,
    & > .navbar:after,
    .navbar-collapse:before,
    .navbar-collapse:after {
        display: none;
    }

    .navbar-header {
        display: flex;
        align-items: center;
        float: none;
        flex-shrink: 0;
        min-height: 56px;
        padding-left: 6px;
    }

    .navbar-brand {
        display: flex;
        align-items: center;
        height: 56px;
        margin: 0 16px 0 0 !important;
        padding: 0 !important;
    }

    .navbar-brand > img {
        height: 30px !important;
        width: auto;
        display: block;
    }

    .navbar-collapse,
    .navbar-collapse.collapse {
        display: flex !important;
        align-items: center;
        justify-content: space-between;
        flex-grow: 1;
        width: auto;
        min-height: 56px;
        padding: 0 16px 0 0;
        border: none;
        box-shadow: none;
        overflow: visible;
    }

    .navbar-nav {
        display: flex;
        align-items: center;
        gap: 2px;
        margin: 0;
        float: none;
    }

    .navbar-nav > li {
        float: none;
    }

    .navbar-nav > li > a,
    .navbar-nav > li.dropdown > a.dropdown-toggle {
        display: flex;
        align-items: center;
        gap: 6px;
        height: 36px;
        padding: 0 12px !important;
        border-radius: 8px;
        background-color: transparent;
        background-image: none;
        color: var(--hdr-text) !important;
        font-size: 13px !important;
        font-weight: 500;
        line-height: 36px;
        white-space: nowrap;
    }

    .navbar-nav > li > a:hover,
    .navbar-nav > li > a:focus,
    .navbar-nav > li.dropdown:hover > a,
    .navbar-nav > li.dropdown.open > a {
        background-color: var(--hdr-hover) !important;
        color: var(--hdr-text-strong) !important;
    }

    .navbar-nav > li > a.active,
    .navbar-nav > li.active > a {
        background-color: var(--hdr-active) !important;
        color: var(--hdr-text-strong) !important;
        font-weight: 600;
        margin: 0;
        min-width: 0;
    }

    .navbar-nav > li > a .caret {
        margin-left: 0;
        border-top-color: #8A97A8;
    }

    .navbar-nav > li.dropdown:hover > .dropdown-menu {
        display: block;
    }

    .navbar-nav > li.dropdown > .dropdown-menu {
        top: calc(100% + 4px);
        margin-top: 0;
        padding: 6px;
        width: 260px;
        border: 1px solid var(--hdr-border);
        border-radius: 10px;
        background-color: var(--hdr-bg);
        background-image: none;
        box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
    }

    .navbar-nav > li.dropdown > .dropdown-menu:before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: -6px;
        height: 6px;
    }

    .navbar-nav > li.dropdown > .dropdown-menu > li > a {
        display: block;
        height: auto;
        padding: 8px 10px;
        border-radius: 6px;
        color: var(--hdr-text) !important;
        font-size: 13px !important;
        line-height: 20px;
        background-image: none;
        background-color: transparent;
    }

    .navbar-nav > li.dropdown > .dropdown-menu > li > a:hover,
    .navbar-nav > li.dropdown > .dropdown-menu > li > a:focus,
    .navbar-nav > li.dropdown > .dropdown-menu > li > a.active {
        background-color: var(--hdr-hover) !important;
        color: var(--hdr-text-strong) !important;
    }

    .navbar-nav > li.dropdown > .dropdown-menu > li.dropdown-header {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 6px 10px 4px;
        color: #9A4B00;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
    }

    .navbar-nav > li.dropdown > .dropdown-menu > li.admin-only > a {
        color: #7A5A2E !important;
    }

    .navbar-nav > li.dropdown > .dropdown-menu > li.divider {
        height: 1px;
        margin: 6px 4px;
        background-color: var(--hdr-border);
    }

    .header-tools {
        display: flex;
        align-items: center;
        gap: 12px;
        margin: 0 0 0 auto;
        padding: 0;
        float: none;
        flex-shrink: 0;
    }

    .navbar-nav > li.dropdown > a.header-user {
        height: 36px;
        padding: 0 10px 0 4px !important;
        border: 1px solid var(--hdr-control-border);
        border-radius: 8px;
        color: #1F2A37 !important;
    }

    .header-user > .avatar {
        width: 28px;
        height: 28px;
        border-radius: 999px;
        background-color: var(--hdr-text-strong);
        color: #FFFFFF;
        font-size: 11px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 0.02em;
    }

    @media (max-width: 1280px) {
        .navbar-nav > li > a,
        .navbar-nav > li.dropdown > a.dropdown-toggle {
            padding: 0 8px !important;
        }

        .header-user > .user-name {
            display: none;
        }
    }
`;
